import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useNavigate } from "react-router-dom";

/**
 * Release plan for mobile.
 * @param props
 * @returns {*}
 * @constructor
 */
function TransactionHistoryMobile(props) {
    const { t, transData, date } = props;
    const navigate = useNavigate();

    function goToDashboard() {
        navigate('/my-app');
    }

    return (
        <div className="transaction-mobile-view">
            <div className="mobile-back-to-test">
                <ArrowBackIcon onClick={goToDashboard}/>
                <span>{t('transactions')}</span>
            </div>
            <ul>
                <div className="transDataLeft">
                    <li>
                        <span className="planName">
                            {transData.plan ? transData.plan.name : ''}
                        </span>
                    </li>
                    <li>
                        <span>{t('TRANSACTION_ID')}</span>
                        <span className="transactionId">{transData.transId}</span>
                    </li>
                    <li>
                        <span>{t('DATE')}</span>
                        <span className="date">{`${date.day} ${date.month}`}</span>
                    </li>
                </div>
                <div className="transDataRight">
                    <li>
                        <span className="amount">₹{transData ? transData.paidAmt : ''}</span>
                    </li>
                    <li>
                        <span>{t('STATUS')}</span>
                        <span
                            className={transData.status === "SUCCESS" ? 'status green-color' : 'status red-color'}>{transData.status}</span>
                    </li>
                    <li>
                        <span>{t('ORDER_ID')}</span>
                        <span className="orderId">{transData ? transData.orderRefNo : ''}</span>
                    </li>
                </div>
            </ul>
        </div>
    );
}

export default TransactionHistoryMobile;
